module.exports = __webpack_public_path__ + "static/durham-img-fa62e762d1d036635cf78d5e5257f74b.jpg";